export default __webpack_public_path__ + "static/media/checkpoint3.93612269.txt";